module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_duo_cp_gaseosas_pet_500_fn.ccf1d65f.png";